import { useEffect, useState } from "react";
const DeviceContext = () => {
    const [device, setDevice] = useState();
    useEffect(() => {
        updateDevice();
        window.addEventListener("resize", updateDevice);
        //updateDevice();
        return () => {
            window.removeEventListener("resize", updateDevice);
            //updateDevice();
        };
    }, []);
    const updateDevice = () => {
        setDevice({
            isMobile: window.innerWidth <= 767 ? true : false,
            isTablet: window.innerWidth > 767 && window.innerWidth < 1024 ? true : false,
            isDesktop: window.innerWidth >= 1024 ? true : false,
        });
    };
    return device;
};
export default DeviceContext;
